import * as cardsApi from '@/network/api/cards/cards.api.js'

/** requests Cards List
@return {promise} - Cards request
*/
export const requestCards = async (context, payload) => {
    const res = await cardsApi.cards(payload)
    if (res) context.commit('SAVE_CARDS', res.data.data)
    return res
}

/** Requests Card Limit
@return {promise}
*/
export const requestCardLimit = async (context, payload) => {
    const res = await cardsApi.requestCardLimit(payload)
    if (res) context.commit('SAVE_CARD_LIMIT', res.data.data)
    return res
}

/** Edit Card Limit
@return {promise}
*/
export const editCardLimit = async (context, payload) => {
    const res = await cardsApi.editCardLimit(payload)
    return res
}

/** Delete Card Limit
@return {promise}
*/
export const deleteCardLimit = async (context, payload) => {
    const res = await cardsApi.deleteCardLimit(payload)
    return res
}

/* ***********************************************
*                   CLEAR ACTIONS                *
*********************************************** */
export const clearFeatureStates = async (context, payload) => {
    context.commit('CLEAR_FEATURES_STATES')
}
